import { api } from '../lib/api'

interface Props {
  label?: string
  /** URL /oidc/authorize à reprendre après la connexion Google (flux OIDC en cours). */
  returnTo?: string | null
  /** Reconnexion exigée par un produit (cf. `SocialButtons`). */
  reconnexion?: boolean
}

/**
 * Bouton Google du portail — même parcours serveur pour la connexion et
 * l'inscription : GET /oauth/google rattache le compte existant ou passe par
 * l'écran de confirmation. Un lien, pas un fetch : OAuth est une navigation,
 * le navigateur doit réellement quitter la page. Affiché par `SocialButtons`,
 * seulement si l'API déclare Google actif.
 */
export function GoogleButton({ label = 'Continuer avec Google', returnTo, reconnexion = false }: Props) {
  return (
    <a
      className="btn btn-secondary btn-google"
      href={api.oauthUrl('google', returnTo ?? undefined, reconnexion)}
    >
      {/* Les quatre couleurs du « G » sont celles de Google et restent écrites
          en dur : c'est un logo tiers, dont la charte d'usage impose les
          valeurs exactes. Aucun jeton de la suite n'a à s'y substituer. */}
      <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
        <path
          fill="#4285F4"
          d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62z"
        />
        <path
          fill="#34A853"
          d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.81.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33A9 9 0 0 0 9 18z"
        />
        <path
          fill="#FBBC05"
          d="M3.97 10.72a5.41 5.41 0 0 1 0-3.44V4.95H.96a9 9 0 0 0 0 8.1l3.01-2.33z"
        />
        <path
          fill="#EA4335"
          d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58C13.46.9 11.43 0 9 0A9 9 0 0 0 .96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58z"
        />
      </svg>
      {label}
    </a>
  )
}
